import { PRODUCT_FIELDS } from '@app/lib/shopify/queries/fragments/product-fields';
import { gql } from 'graphql-request';

const productByHandle = gql`
    query ProductByHandleQuery($country: CountryCode, $handle: String!)
    @inContext(country: $country) {
        product(handle: $handle) {
            ...ProductFields
        }
    }
    ${PRODUCT_FIELDS}
`;
export default productByHandle;
